import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './include/header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { materialModule }from './material.module';


import { HttpClientModule } from '@angular/common/http';
import { DataserviceService } from './service/dataservice.service';
import { DndDirective } from './common/directive/drag-drop.directive';
import { ProgressComponent } from './common/progress/progress.component';
import { UserService } from './service/user.service';
import { TematicaService } from './service/tematica.service';
import { DataService } from './common/data.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PasswordComponent } from './change/change.component';
import { UserComponent } from './user/user.component';
import { FormUserComponent } from './user/form/form-user.component';
import { AdminComponent } from './admin/admin.component';


import { ConfirmDialogComponent } from './util/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogTicketComponent } from './util/confirm-dialog-ticket/confirm-dialog-ticket.component';
import { LoginComponent } from './login/login.component';
import { MsjDialogService } from './service/msjDialogService';
import { AuthGuardService } from './login/AuthGuardService';
import { AvatarModule } from 'ngx-avatar';
import { EmailMaskDirective } from './common/directive/email-mask.directive';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ConfirmDialogComponent,
    ConfirmDialogTicketComponent,
    LoginComponent,
    PasswordComponent,
    DashboardComponent,
    UserComponent,
    FormUserComponent,
    AdminComponent,
    ProgressComponent,
    EmailMaskDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    materialModule,
    HttpClientModule,
    AvatarModule
  ],
  providers: [DataserviceService, MsjDialogService, AuthGuardService, DataService, UserService, TematicaService], 
  bootstrap: [AppComponent]
})
export class AppModule { }
